require('./jquery-localization/defaults');
require('./jquery-localization/messages_es');
require('./jquery-localization/messages_pt');
require('./jquery-localization/messages_fr');
